// AudioEvents file with all events

export interface PlayAudioDetail {
    previewUrl: string;
    isPlaying: boolean;
}

// Base class for all audio events
export class AudioEvent extends Event {
    public readonly src: string;
    public readonly time?: number;

    constructor(type: string, src: string, time?: number) {
        super(type);
        this.src = src;
        this.time = time;
    }
}

// Play event
export class PlayEvent extends AudioEvent {
    static readonly TYPE = 'audio:play';

    constructor(src: string, time?: number) {
        super(PlayEvent.TYPE, src, time);
    }
}

// Pause event
export class PauseEvent extends AudioEvent {
    static readonly TYPE = 'audio:pause';

    constructor(src: string) {
        super(PauseEvent.TYPE, src);
    }
}

// TimeUpdate event
export class TimeUpdateEvent extends AudioEvent {
    static readonly TYPE = 'audio:timeupdate';

    constructor(src: string, time: number) {
        super(TimeUpdateEvent.TYPE, src, time);
    }
}

// Seek event
export class SeekEvent extends AudioEvent {
    static readonly TYPE = 'audio:seek';

    constructor(src: string, time: number) {
        super(SeekEvent.TYPE, src, time);
    }
}

// Ended event
export class EndedEvent extends AudioEvent {
    static readonly TYPE = 'audio:ended';

    constructor(src: string) {
        super(EndedEvent.TYPE, src);
    }
}

export class VolumeChangedEvent extends AudioEvent {
    static readonly TYPE = 'audio:volumechanged';
    public readonly volume: number;

    constructor(src: string, volume: number) {
        super(VolumeChangedEvent.TYPE, src);
        this.volume = volume;
    }
}

// Audio events constants for easy reference
export const AUDIO_EVENTS = {
    PLAY: PlayEvent.TYPE,
    PAUSE: PauseEvent.TYPE,
    TIMEUPDATE: TimeUpdateEvent.TYPE,
    SEEK: SeekEvent.TYPE,
    ENDED: EndedEvent.TYPE,
    VOLUME_CHANGED: VolumeChangedEvent.TYPE,
};
